import  ApiService  from '../../services/api.service'
import HashMake from '../../services/hash.service'

const state =  {
    response: {
        message: '',
        variant: '',
        errmsg: []
    },
    isShow: false,
    loading: false
}

const getters = {
    isShow: (state) => state.isShow,
    response: (state) => state.response,
    loading: state => state.loading,
}

const actions = {
    setIsShow({ commit }, value) {
        commit('setIsShow', value)
    },
    changePassword({ commit }, formdata) {
        let password = HashMake.encrypt(formdata.password)
        let oldpassword = HashMake.encrypt(formdata.oldpassword)     
        let lang = formdata.lang

        var formData = new FormData()
        formData.append("password", password)
        formData.append("oldpassword", oldpassword)
        formData.append("lang", lang)

        return new Promise((resolve, reject) => {
            commit('setLoading', true)
            ApiService.post('/change-password', formData)
                .then(response => {
                    commit('setResponse', response.data)
                    resolve();
                })
                .catch(error => {
                    commit('setResponse', error.response.data)
                    reject(error);
                })
                .finally(() => {
                    commit('setLoading', false);
                });
        });
    },
}

const mutations = {
    setIsShow(state, isShow) {
        state.isShow = isShow
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setResponse(state, data) {
        state.response.message = data.message;
        if(data.success == true) {
            state.response.variant = 'success';
        } else {
            state.response.variant = 'danger';
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}